<template>
  <div>
    <b-row>
      <b-col cols="4" v-if="file">
          <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
              <div>
              ملف العقوبة  
              </div>
              <div>
              <b-button
              
                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:file  } }"
              >
                  <feather-icon icon="EyeIcon"
              /></b-button>
              </div>
          </div>
          <div>
              <hr />
          </div>
          </div>
      </b-col> 
      <b-col md="4" cols="12" v-else> 
        <info-card
            label="نوع العقوبة"
            :value="data.punishment_id ? data.punishment_id.name : ''"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-2">
        <h5>
          المُرفقات :
        </h5>
      </b-col>
      <b-col cols="4" v-for="file in data.files">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              {{ file.name }}
            </div>
            <div>
              <b-button
                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:file.file } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import router from "@/router";
import axios from "@axios";
export default {
  components: {
    BCard, BImg , BCol , InfoCard , BRow , BButton
  },
  props: {
    data : Object ,
  },
  methods:{

  },
  data() {
      return {
          file: '',
      }
  },

  watch: {
      data: {
      handler: async function(newVal, oldVal) {
          
          const currentRoute = router.currentRoute.path.includes('ministry')
          if(currentRoute){
              console.log("currentRoute" , currentRoute)
              await axios.get(`v2/ministry/ngo-incentives/${this.data.punishment_id.id}`).then((res) => this.file=res.data.data.source);
          }
          else{
              this.file=null
          }
      },
      deep: true
      }
  },
  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
};
</script>